import * as texts from "@/services/texts.js"
import * as styles from "@/services/styles.js"
import { intervalPeriods, paywallSourceTypes } from "@/constants/paywall.js"
import routes from "@/routes.js"

import { useAppStateStore } from "@/store/appState.js"

export const getPaywallDataWithUniformBillingPeriods = (paywallData) => {
  const onlyWebPaywallData = {
    ...paywallData,
    plans: paywallData.plans.filter((p) => p.web_subscriptions.length)
  }

  const billingPeriods = onlyWebPaywallData.plans.map((p) => p.web_subscriptions.map((ws) => ws.interval_period))

  if (billingPeriods.length && billingPeriods.every((bp) => bp.length === 1 && bp[0] === billingPeriods[0][0])) {
    onlyWebPaywallData.commonBillingPeriod = billingPeriods[0][0]
    return onlyWebPaywallData
  }

  return {
    ...onlyWebPaywallData,
    plans: onlyWebPaywallData.plans.filter((p) => {
      return (
        p.web_subscriptions.find((ws) => ws.interval_period === intervalPeriods.MONTH) &&
        p.web_subscriptions.find((ws) => ws.interval_period === intervalPeriods.YEAR)
      )
    })
  }
}

export const applyApiPaywallDecriptionStyles = (paywallData) => {
  if (paywallData.paywall_description) {
    styles.extractStyleElementFromHTMLAndInjectToDocument({
      html: paywallData.paywall_description,
      tagId: "api-paywall-description-styles"
    })
  }
}

export const applyApiPaywallPlanStyles = (paywallData) => {
  const planDescription = paywallData.plans.find((p) => p.description)?.description

  if (planDescription) {
    styles.extractStyleElementFromHTMLAndInjectToDocument({
      html: planDescription,
      tagId: "api-paywall-plan-styles"
    })
  }
}

export const getFormattedSubscriptionPrice = ({ price_in_cents, currency, currency_subunit_to_unit }) => {
  return texts.formatCurrency({
    priceInCents: price_in_cents,
    currencyType: currency,
    subunitToUnit: currency_subunit_to_unit,
    trimCentsIfZero: true
  })
}

export const getRouteAfterSubscriptionSuccess = () => {
  const appStateStore = useAppStateStore()
  const { sourceType, sourceId, routeParamId } = appStateStore.lastPaywallSource || {}

  switch (sourceType) {
    case paywallSourceTypes.ARTICLE:
      return { name: routes.ARTICLE, params: { articleId: sourceId } }
    case paywallSourceTypes.EVENT_BUTTON:
      return { name: routes.EVENT, params: { id: routeParamId } }
    case paywallSourceTypes.ASSET:
      return { name: routes.FOLDER, params: { folderId: routeParamId } }
    case paywallSourceTypes.FOLDER:
      return { name: routes.FOLDER, params: { folderId: sourceId } }
    case paywallSourceTypes.LINK_BUTTON:
    case paywallSourceTypes.POST:
      return { name: routes.POST, params: { postId: sourceId } }
    case paywallSourceTypes.LIVESTREAM:
      return { name: routes.LIVE, params: { id: sourceId } }
    default:
      return { name: routes.ROOT }
  }
}

export const registerLastSource = (lastSourceData) => {
  const appStateStore = useAppStateStore()
  appStateStore.setLastPaywallSource(lastSourceData)
}
